import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { SOCIAL_MEDIA_LABELS, SOCIAL_MEDIA_PLACEHOLDERS, getSocialMedias } from '@/utils';
import Tooltip from '@/components/Tooltip';
import Icon from '@/components/Icon';
import Button from '@/components/Button';
import Popover from '@/components/Popover';
import Form from '@/components/Form';
import LoadingButton from '@/components/LoadingButton';
import FormField from '@/components/FormField';
import { TextInput } from '@/components/Inputs';
import ExternalLink from '@/components/ExternalLink';

const propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  socialMedia: PropTypes.object,
  onEditContact: PropTypes.func,
  contact: PropTypes.object
};

const defaultProps = {
  socialMedia: {},
  onEditContact: () => {},
  contact: {}
};

/* eslint-disable no-magic-numbers */
const schema = Yup.object().shape({
  contact: Yup.object().shape({
    facebook: Yup.string()
      .max(255, 'Facebook deve ter no máximo 255 caracteres'),
    twitter: Yup.string()
      .max(255, 'Twitter deve ter no máximo 255 caracteres'),
    linkedin: Yup.string()
      .max(255, 'LinkedIn deve ter no máximo 255 caracteres'),
    instagram: Yup.string()
      .max(255, 'Instagram deve ter no máximo 255 caracteres'),
    skype: Yup.string()
      .max(255, 'Skype deve ter no máximo 255 caracteres')
  })
});
/* eslint-enable no-magic-numbers */

function getContactAttributes(contact = {}) {
  return {
    contact: {
      facebook: contact.facebook ?? '',
      twitter: contact.twitter ?? '',
      linkedin: contact.linkedin ?? '',
      instagram: contact.instagram ?? '',
      skype: contact.skype ?? ''
    }
  };
}

function SocialMediaPopover({ label, onEditContact, contact }) {
  const [openPopover, setOpenPopover] = useState(false);
  const initialValues = getContactAttributes(contact);
  const socialMedias = getSocialMedias(contact);
  const socialMedia = socialMedias.find((sm) => sm.name === label) ?? {};

  const handleSubmitSocialMedia = (values, onHide, setSubmitting) => {
    onEditContact({
      contact: { [label]: values.contact[label] }
    }, () => {
      setSubmitting(false);
      onHide();
    });
  };

  const handleClickIcon = () => {
    setOpenPopover(!openPopover);
  };

  const tooltipText = socialMedia.url
    ? socialMedia.url.replace(/^https?:\/\/(?:www\.)?/u, '')
    : `O ${SOCIAL_MEDIA_LABELS[label]} desse contato está vazio. Clique para definir.`;

  return (
    <Popover
      placement='top'
      showArrow
      show={openPopover}
      onHide={() => setOpenPopover(false)}
      content={({ onHide }) => (
        <div className='py-4 d-flex flex-column' style={{ width: 300 }}>
          <h4 className='mb-4'>Adicionar Rede Social</h4>
          <Form
            name='social-media-form'
            validationSchema={schema}
            initialValues={initialValues}
            onSubmit={(
              values,
              { setSubmitting }
            ) => handleSubmitSocialMedia(values, onHide, setSubmitting)}
          >
            {({ isSubmitting, handleSubmit }) => (
              <>
                <FormField
                  name={`contact.${label}`}
                  as={TextInput}
                  label={SOCIAL_MEDIA_LABELS[label]}
                  placeholder={SOCIAL_MEDIA_PLACEHOLDERS[label]}
                  maxLength={255}
                />
                <div className='d-flex justify-content-end mt-2 gap-2'>
                  <Button
                    variant='link'
                    onClick={onHide}
                    className='fw-bold'
                  >
                    Cancelar
                  </Button>
                  <LoadingButton
                    variant='primary'
                    isLoading={isSubmitting}
                    onClick={handleSubmit}
                  >
                    Salvar
                  </LoadingButton>
                </div>
              </>
            )}
          </Form>
        </div>
      )}
    >
      <div className='d-inline-block'>
        <Tooltip content={tooltipText} placement='top'>
          {
            socialMedia.url
              ? (
                <ExternalLink
                  href={socialMedia.url}
                  target='_blank'
                  onClick={(event) => event.stopPropagation()}
                >
                  <Icon
                    name={label}
                    className='cursor-pointer text-primary'
                    onClick={handleClickIcon}
                  />
                </ExternalLink>
              )
              : (
                <div onClick={handleClickIcon}>
                  <Icon name={label} className='cursor-pointer text-medium-gray' />
                </div>
              )
          }
        </Tooltip>
      </div>
    </Popover>
  );
}


SocialMediaPopover.propTypes = propTypes;
SocialMediaPopover.defaultProps = defaultProps;

export default SocialMediaPopover;
